import type { AiAppCenterModule } from '../types'

export const supplierModule: AiAppCenterModule = {
  key: 'supplier',
  label: '供应商后台',
  desc: '供应商登录 / 新品提报货品池（发货对账后置）',
  path: '/supplier',
  standalonePath: '/supplier/login',
  homePath: '/supplier/login',
  icon: 'ep:office-building',
  color: '#0f766e',
  openMode: 'plain',
  aliases: ['供应商平台', 'S端', '货品池上传']
}
